import { Box, Divider, Grid, styled, Typography } from '@mui/material';
import { TextField } from '@chargeafter/ui';

export const StyledGridItem = styled(Grid)({
  height: 'calc(100vh - 20px - 64px - 48px)', //same as panel
});

export const StyledCartGrid = styled(Grid)({
  height: '100%',
  marginTop: '-2px',
});

export const StyledMinimumRibbon = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  justifyContent: 'center',
  padding: theme.spacing(1),
}));

export const StyledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800],
}));

export const StyledCartHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: theme.spacing(5),
  padding: theme.spacing(0, 4),
}));

export const StyledSingleCartContainer = styled(Box)(({ theme }) => ({
  height: `calc(55% - ${theme.spacing(9)})`,
  padding: theme.spacing(2, 4),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

export const StyledOrderIdTextField = styled(TextField)({
  input: {
    textAlign: 'center',
  },
});

export const PaymentsContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  borderLeft: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(4, 0),
}));

export const StyledPaymentOption = styled(Box)(({ theme }) => ({
  padding: theme.spacing(0, 4),
}));

export const StyledButtonWrapper = styled(Box)({
  width: '100%',
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  gap: 16,
});

export const StyledOutlinedBox = styled(Box)(({ theme }) => ({
  borderRadius: 8,
  borderWidth: 2,
  borderStyle: 'solid',
  borderColor: theme.palette.grey[200],
}));

export const StyledDivider = styled(Divider)({
  margin: '20px 0',
});

export const StyledCustomerInnerDetailsBox = styled(Box)({
  '& > *': {
    padding: '5px 0',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
});
